import { CartItemFragment } from '@/features/graphql/generated/graphql'
import { CartItemWithIndex } from '@/features/pos/components/Cart/types'

export const appendCartItem = (
    items: CartItemFragment[] = [],
    item: CartItemFragment
): CartItemFragment[] => items.concat(item)

export const insertCartItem = (
    items: CartItemFragment[] = [],
    item: CartItemFragment,
    index: number
): CartItemFragment[] => items.toSpliced(index, 0, item)

export const removeCartItem = (
    items: CartItemFragment[] = [],
    itemUuid: string
): CartItemFragment[] => items.filter(({ uuid }) => uuid !== itemUuid)

export const findCartItemWithIndex = (
    items: CartItemFragment[] = [],
    itemUuid: string
): CartItemWithIndex | undefined => {
    const index = items.findIndex(({ uuid }) => uuid === itemUuid)

    if (index === -1) return undefined

    return { item: items[index], index }
}
